import { useContext } from 'react';
import './header.css';
import SelectCompanie from '../SelectCompanie';
import { AuthContext } from '../../contexts/auth';
import "react-bootstrap-submenu/dist/index.css";

import { Link } from 'react-router-dom';
import { FaSignInAlt } from "react-icons/fa";

export default function Header(){
  const { signOut, companies } = useContext(AuthContext);

  return(
    <div className="topbar">
      <div className="title-companie">
        <Link to="/dashboard">
          <h2>WMS Gruppe</h2>
        </Link>
      </div>
      <div className="select-companie">
        <SelectCompanie />
      </div>
      <div className="button-exit">
        <Link to="/" onClick={signOut}>
          <FaSignInAlt color="#F1E636" size={24} />
          Sair
        </Link>
      </div>
    </div>
  )
}